<template>
  <div>{{ numFormated }}</div>
</template>

<script>
import { isEmpty } from 'lodash';

export default {
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            numFormated: '',
        };
    },
    mounted() {
        this.formatPhoneNumber(this.item);
    },
    methods: {
        // +14387962218 to +1 (438) 796-2218',
        formatPhoneNumberUSorCA(phoneNumber) {
            const cleaned = (`${ phoneNumber}`).replace(/\D/g, '');
            const match = cleaned.match(/^(\d{1})(\d{3})(\d{3})(\d{4})$/);
            if (match) {
                return `+${match[1]} (${match[2]}) ${match[3]}-${match[4]}`;
            }
            return phoneNumber; // Retourn le numero non formaté s'il ne peut pas l'être
        },
        /* +447987654321 en 44 79 8765 4321 */
        formatPhoneNumberUK(phoneNumber) {
            const cleaned = (`${ phoneNumber}`).replace(/\D/g, '');
            const match = cleaned.match(/^(\d{2})(\d{2})(\d{4})(\d{4})$/);
            if (match) {
                return `+${match[1]} ${match[2]} ${match[3]} ${match[4]}`;
            }
            return phoneNumber;
        },
        /* +493012345678 en +49 30 12345678 */
        formatPhoneNumberDE(phoneNumber) {
            const cleaned = (`${ phoneNumber}`).replace(/\D/g, '');
            const match = cleaned.match(/^(\d{2})(\d{2})(\d{8})$/);
            if (match) {
                return `+${match[1]} ${match[2]} ${match[3]}`;
            }
            return phoneNumber;
        },

        formatPhoneNumber(item) {
            if (item?.phoneNumber) {
                switch (item.phoneNumber.countryCode) {
                    case 'US':
                    case 'CA':
                        this.numFormated = this.formatPhoneNumberUSorCA(item.phoneNumber.number);
                        break;
                    case 'GB':
                        this.numFormated = this.formatPhoneNumberUK(item.phoneNumber.number);
                        break;
                    case 'DE':
                        this.numFormated = this.formatPhoneNumberDE(item.phoneNumber.number);
                        break;
                    default:
                        if (isEmpty(item.phoneNumber)) this.numFormated = '';
                        else this.numFormated = item.phoneNumber.number || item.phoneNumber;
                        break;
                }
            }
        },
    },
};
</script>
